import React, { useEffect } from "react";
// mui
import { Grid2 } from "@mui/material";
//styling
import styles from "./Alerts.module.scss";
// local import
import SiteHeaderCard from "../../Components/HeaderComponent/Header";
import { useSelector } from "react-redux";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import {
  adminApi,
  lastSegmentPath,
  STAGING,
} from "../../../../../../Utils/roconConstants";
import {
  getStagingEnv,
  siteDetails,
  staging,
} from "../../../../../../Utils/sitePages";
import { ReactComponent as AlertsPic } from "../../../../../../GlobalAssets/svg/NoAlerts.svg";
import { useLocation, useParams } from "react-router-dom";
import AlertsTable from "./Components/AlertsTable";

export default function Alerts() {
  let sites = useSelector((state) => state?.sitesInfo?.selectedSite);
  let organizationsInfo = useSelector(
    (state) => state.organizationsInfo.selectedOrg
  );

  const params = useParams();
  const orgId = params.orgId;
  const siteId = params.siteId;

  const siteData = siteDetails(sites);
  let livedom = siteData?.domain.find((item) => item.primary === "Y")?.name;
  const selectedDomain = useSelector((state) => state.sitesInfo.selectedDomain);

  const isStaging = staging(sites);
  const location = useLocation();
  const lastSegment = lastSegmentPath(location);

  useEffect(() => {
    getStore().dispatch({
      type: Actions.API_GET_SELECTED_SITE_DETAILS,
      data: { siteId: siteId },
      meta: {
        onSuccess: (data) => {
          let sitename = data?.domainName;
          getStore().dispatch({
            type: Actions.API_GET_ALERTS,
            data: {
              siteId: siteId,
              stagingDomainName:
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : sitename,
            },
          });
          const selectedEnvData = data.stagingDomainsList.find(
            (list) =>
              list?.environment ===
              (selectedDomain?.environment === "STAGING" ? "STAGING" : "LIVE")
          );
          getStore().dispatch({
            type: Actions.SET_SELECTED_DOMAIN,
            data: selectedEnvData,
          });
        },
        onError: () => {},
      },
    });
    getStore().dispatch({
      type: Actions.SET_SITE_DETAILS,
      data: {
        orgId: orgId,
        siteId: siteId,
        sitePage: lastSegment,
      },
    });
  }, [siteId, selectedDomain?.environment]);

  const rows =
    siteData?.alerts?.map((item) => ({
      type: item?.alertType,
      date: item?.dateTime,
      download: item?.downloadLogFile,
      severity: item?.severity,
    })) || [];

  return (
    <>
      <Grid2 className={styles.Container}>
        <Grid2 className={styles.header}>Alerts</Grid2>
        {siteData?.siteName && (
          <SiteHeaderCard
            name={
              selectedDomain?.environment === "STAGING"
                ? selectedDomain.domainName
                : siteData.siteName
            }
            domain={
              livedom?.length > 0 && selectedDomain?.environment === "LIVE"
                ? livedom
                : (selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : siteData.siteName) +
                  "." +
                  process.env.REACT_APP_TEMP_DOMAIN
            }
            development={isStaging}
            production={getStagingEnv(siteData.staging, STAGING.LIVE)}
            phpClick={() => adminApi("php")}
            wpClick={() =>
              adminApi(
                "wp",
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData.siteName,
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : livedom?.length > 0
                  ? livedom
                  : null,
                selectedDomain?.environment === "STAGING" ? true : false
              )
            }
            domainClick={() =>
              adminApi(
                "domain",
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData.siteName,
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : livedom?.length > 0
                  ? livedom
                  : null,
                selectedDomain?.environment === "STAGING" ? true : false
              )
            }
            siteId={siteId}
            orgId={orgId}
            image={siteData.imagePath ? siteData.imagePath : null}
            orgInfo={organizationsInfo}
            addOnWaf={siteData.wafStatus}
            addOnPerformanceSite={siteData.performanceSite}
          />
        )}
        {siteData?.alerts?.length > 0 ? (
          <AlertsTable rows={rows} />
        ) : (
          <Grid2 className={styles.noalert}>
            <AlertsPic />
            <Grid2 className={styles.desc}>No Alerts</Grid2>
          </Grid2>
        )}
      </Grid2>
    </>
  );
}
